import script from "./HeaderNew.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNew.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNew.vue?vue&type=style&index=0&id=5dfe1faa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dfe1faa"]])

export default __exports__